const report_store = {
    state: {
        document: null,
        creatingDocuments: false,
        campaignId: null,
        selectedFacility: null,
    },
    getters: {
        document: (state) => state.document,
        creatingDocuments: (state) => state.creatingDocuments,
        campaignId: (state) => state.campaignId,
        selectedFacility: (state) => state.selectedFacility,
    },
    mutations: {
        setDocument: (state, payload) => {
            state.document = payload;
        },
        setCreatingDocuments: (state, payload) => {
            state.creatingDocuments = payload;
        },
        setCampaignId: (state, payload) => {
            state.campaignId = payload;
        },
        setSelectedFacility: (state, payload) => {
            state.selectedFacility = payload;
        },
    }
};

export default report_store;
